import React from 'react';
import './Header.scss';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import { IconNavigationArrowLeft } from '@bcmi-labs/icons';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Header = (props) => {
  const { onBack } = props;

  return (
    <div className="header-container">
      {onBack ? (
        <button className="icon-button" onClick={onBack} aria-label="Go back">
          <IconNavigationArrowLeft />
        </button>
      ) : null}
      <div className={classnames('logo-wrapper', { 'with-back': onBack })}>
        <Logo />
      </div>
    </div>
  );
};

Header.propTypes = {
  onBack: PropTypes.func,
};

export default Header;
